import { render, staticRenderFns } from "./MaterialMappers.vue?vue&type=template&id=5a5c6774&"
import script from "./MaterialMappers.vue?vue&type=script&lang=js&"
export * from "./MaterialMappers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports